// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1880":"08349eeb","4585":"4795e4d1","5008":"4795e4d1","9450":"4795e4d1","9755":"4795e4d1"}[chunkId] + ".chunk.css";
};